import { CompanySettings, CustomCompanySettings, Member } from '../types';
import { utilities } from '../utils/utilities';

import AuthRequests from './auth.requests';

class CompanyRequests {
  static putCompanySettings(companyId: string, settings: Partial<CompanySettings>) {
    const { custom = {}, ...restSettings } = settings;

    const customWithoutMembers = { ...custom };
    delete customWithoutMembers.memberstoinvite;

    const cleanedSettings: Partial<CompanySettings> = {
      ...restSettings,
      custom: customWithoutMembers,
    };

    return AuthRequests.axiosInstance.put(
      `/1.0/companies/${ companyId }`,
      utilities.flatObj(cleanedSettings),
    );
  }

  static updateMembersToInvite(companyId: string, membersToInvite: Member[],
    existingCustomSettings: CustomCompanySettings = {}) {
    return AuthRequests.axiosInstance.put(
      `/1.0/companies/${ companyId }`,
      {
        custom: {
          ...existingCustomSettings,
          memberstoinvite: membersToInvite,
        },
      },
    );
  }
}

export default CompanyRequests;

